import React, { Component } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import translations from "../../../translations";

class About extends Component{
    static contextType = LanguageContext;

    render(){
        const { language } = this.context;
        const t = translations[language];

        let title = t.homepage.about.title,
        description = t.homepage.about.description;

        let counterData = [
            {
                countNum : 35,
                countTitle: t.homepage.about.counters.experience,
            },
            {
                countNum : 151,
                countTitle: t.homepage.about.counters.projects,
            },
            {
                countNum : 42,
                countTitle: t.homepage.about.counters.aiProjects,
            },
        ];

        return(
            <React.Fragment>
                <div className="about-wrapper">
                    <div className="container" >
                        <div className="row row--35 align-items-center">

                            <div className="col-lg-5 col-md-12">
                                <div className="thumbnail">
                                    <div className="massdev-logo-container">
                                        <div className="massdev-logo-text">
                                            <span className="mass-text">Mass</span>
                                            <span className="dot-text">.</span>
                                            <span className="dev-text">Dev</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-7 col-md-12">
                                <div className="about-inner inner">
                                    <div className="section-title">
                                        <span className="subtitle theme-gradient pt-4 mt-4">{t.homepage.about.subtitle}</span>
                                        <h2 className="title">{title}</h2>
                                        <p className="description">{description}</p>
                                    </div>
                                    <div className="row mt--30 mt_sm--10">
                                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div className="about-us-list">
                                                <h3 className="title">{t.homepage.about.fintechTitle}</h3>
                                                <p>{t.homepage.about.fintechDesc}</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div className="about-us-list">
                                                <h3 className="title">{t.homepage.about.aiTitle}</h3>
                                                <p>{t.homepage.about.aiDesc}</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Counter Stats Section */}
                                    <div className="about-counter-wrapper">
                                        <div className="row">
                                            {counterData.map((value, index) => (
                                                <div className="col-lg-4 col-md-4 col-sm-6 col-12" key={index}>
                                                    <div className="about-counter-item">
                                                        <h5 className="counter">
                                                            {value.countNum}<span className="plus-icon">+</span>
                                                        </h5>
                                                        <p className="description" >{value.countTitle}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default About;